const TR_MAP: Record<string, string> = {
  ç: 'c',
  Ç: 'c',
  ğ: 'g',
  Ğ: 'g',
  ı: 'i',
  I: 'i',
  İ: 'i',
  ö: 'o',
  Ö: 'o',
  ş: 's',
  Ş: 's',
  ü: 'u',
  Ü: 'u',
};

const slugPart = (s: string): string => {
  const mapped = s
    .split('')
    .map((ch) => TR_MAP[ch] ?? ch)
    .join('');

  // remove diacritics (é -> e etc.)
  const noDiacritics = mapped.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return noDiacritics
    .toLowerCase()
    .trim()
    .replace(/[\s]+/g, '-') // spaces -> -
    .replace(/[^a-z0-9_-]/g, '') // keep only allowed chars
    .replace(/-+/g, '-') // collapse ---
    .replace(/^[-_]+|[-_]+$/g, ''); // trim - _
};

const randomSuffix = (len = 4): string => {
  // base36 = [0-9a-z]
  return Math.random()
    .toString(36)
    .slice(2, 2 + len);
};

export const generateAffiliateCode = (
  firstName: string,
  lastName: string,
): string => {
  const first = slugPart(firstName);
  const last = slugPart(lastName);

  let base = [first, last].filter(Boolean).join('-');
  if (!base) base = 'affiliate';

  // Ensure max length 32 (keep room for suffix if we need it)
  if (base.length > 32) base = base.slice(0, 32).replace(/^[-_]+|[-_]+$/g, '');

  // Ensure min length 3
  if (base.length < 3) {
    base = `${base}-${randomSuffix(3)}`.slice(0, 32);
  }

  // Final safety: must match backend regex
  base = base.replace(/[^a-z0-9_-]/g, '');
  if (base.length < 3) base = `aff-${randomSuffix(4)}`;
  if (base.length > 32) base = base.slice(0, 32);

  return base;
};
